import { Directive } from '@angular/core';
import {
  ReactiveFormsModule,
  NG_VALIDATORS,
  FormsModule,
  FormGroup,
  UntypedFormControl,
  ValidatorFn,
  Validator
} from '@angular/forms';

@Directive({
    selector: '[haven-emailValidator][ngModel]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: EmailValidatorDirective,
            multi: true
        }
    ],
    standalone: false
})
export class EmailValidatorDirective implements Validator {
  validator: ValidatorFn;
  constructor() {
    this.validator = this.emailValidator();
  }
  validate(c: UntypedFormControl) {
    return this.validator(c);
  }
  emailValidator(): ValidatorFn {
    return (c: UntypedFormControl) => {
      const isValid = /^((?!\.)[\w.\-_${}!'#=]*[^.])(@\w+)(\.\w+(\.\w+)?[^.\W])$/.test(
        c.value
      );
      if (isValid) {
        return null;
      } else {
        return {
          emailValidator: {
            valid: false
          }
        };
      }
    };
  }
}
